import { AlertTriangle, LoaderCircle } from 'lucide-react'

export function Loading({ text = 'Loading live marketplace data…' }: { text?: string }) {
  return <div className="state-card"><LoaderCircle className="spin"/><b>{text}</b></div>
}

export function ErrorState({ error, retry }: { error: string; retry?: () => void }) {
  return <div className="state-card error"><AlertTriangle/><div><b>Unable to load</b><span>{error}</span></div>{retry && <button className="btn secondary" onClick={retry}>Retry</button>}</div>
}

export function Empty({ title, text }: { title: string; text: string }) {
  return <div className="state-card"><div><b>{title}</b><span>{text}</span></div></div>
}
